import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { AuthService } from '../security';

@Injectable({ providedIn: 'root' })
export class RedirectEditionNephroGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot) {
        const { id } = route.params;
        if (this.authService.canEditMedicalInfos.nephro) {
            this.router.navigate(['multiform', 'edition-nephro', id, 'inclusionMode']);
            return true;
        }
        if (this.authService.canEditAdministrativeInfos.nephro) {
            this.router.navigate(['multiform', 'edition-nephro', id, 'identity']);
            return true;
        }
        return false;
    }
}
